(function () {
  const initHeroBanner = (section) => {
    if (!section || !section?.classList.contains("hero-section")) return;

    const container = section.querySelector(".hero.animate");

    if (!container) return;

    if (container.classList.contains("hero--first-section")) {
      container.classList.add("animated");
      return;
    }

    ScrollTrigger.create({
      trigger: container,
      start: "50% bottom",
      end: "bottom top",
      onEnter: () => container.classList.add("animated"),
    });
  };

  initHeroBanner(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (e) {
    initHeroBanner(e.target);
  });
})();